<template>
  <div class="news-list">
    <div class="news-item flex-row justify-between" v-for="(item, index) in items" :key="index" @click="goDetail(item)">
      <div class="news-thumb-box">
        <img class="news-thumb" referrerpolicy="no-referrer" :src="item.img ? item.img : defaultThumb" />
      </div>
      <div class="news-info flex-col">
        <span class="news-title">{{ item.title }}</span>
        <span class="news-date">{{ item.date || item.publishTime || item.createTime }}</span>
      </div>
    </div>
    <div class="empty-state" v-if="items.length === 0">
      <p class="empty-state-text">暂无数据</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsList',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      defaultThumb: require('../assets/img/article-thumb-1.png')
    }
  },
  methods: {
    goDetail(item) {
      if (item && item.id) {
        this.$router.push('/article/' + item.id)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.news-list {
  margin-top: 13px;
  .news-item {
    box-shadow: 0px 2px 14px 0px rgba(204, 204, 204, 0.5);
    background-color: rgba(255, 255, 255, 1);
    border-radius: 8px;
    width: 343px;
    margin-bottom: 10px;
    padding: 12px 16px 12px 12px;
    cursor: pointer;
    transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    &:active {
      transform: scale(0.97);
      opacity: 0.85;
    }

    .news-thumb-box {
      width: 114px;
      height: 76px;
      overflow: hidden;
      border-radius: 4px;
      flex-shrink: 0;
    }
    .news-thumb {
      width: 100%;
    }

    .news-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .news-title {
        width: 185px;
        height: 54px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 18px;
        text-align: justify;
        font-style: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .news-date {
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgba(142, 142, 142, 1);
        font-size: 12px;
        text-align: left;
        white-space: nowrap;
        line-height: 17px;
      }
    }
  }
}
</style>
